import React from "react";
import SpinnerComponent from "../../components/atoms/spinner/spinner.component";

const CategoryListTemplate = ({ templateData, templateEvent }) => {
  const { categories, loading } = templateData;
  const { onLoad, handleViewDetails } = templateEvent;

  return (
    <div className="ds-container">
      {loading ? (
        <div style={{ textAlign: "center", padding: 64 }}>
          <SpinnerComponent />
        </div>
      ) : (
        <>
          <div className="ds-page-head">
            <p className="ds-eyebrow">Browse the catalog</p>
            <h1>All categories</h1>
          </div>
          <div className="ds-card-grid cols-4" style={{ paddingBottom: 56 }}>
            {categories?.categories?.map((category) => (
              <div key={category.id} className="ds-category-card">
                <span
                  className="ds-thumb"
                  style={{ aspectRatio: "auto", height: 120, borderRadius: "var(--radius-md)", marginBottom: 12 }}
                >
                  {category.image ? <img src={category.image} alt={category.name} /> : null}
                </span>
                <h4>{category.name}</h4>
                <p>
                  {category.description?.substring(0, 100)}
                  {category.description?.length > 100 ? "..." : ""}
                </p>
                <button
                  className="ds-btn ds-btn-secondary ds-btn-sm ds-mt-l"
                  onClick={() => handleViewDetails(category.unique_id)}
                >
                  View Details
                </button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default CategoryListTemplate;
